/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { or } from '@ember/object/computed';
import { GREEN_500, YELLOW_500, GRAY_400 } from 'cio/utils/colors';
import ActionModel from 'cio/models/action';

interface VisualWorkflowBuilderWorkflowActionVariationStatusArgs {
  parentAction: ActionModel;
  badge: {
    label: string;
    color: string;
    allocation: number;
    active: boolean;
    paused: boolean;
  };
}

export default class VisualWorkflowBuilderWorkflowActionVariationStatus extends Component<VisualWorkflowBuilderWorkflowActionVariationStatusArgs> {
  @or('args.parentAction.isSplitRunning', 'args.badge.active') isActive!: boolean;

  @computed('isActive', 'args.parentAction.{isSplitPaused,isSplitInactive}')
  get dotColor() {
    if (this.isActive) {
      return GREEN_500;
    }

    if (this.args.parentAction.isSplitPaused) {
      return YELLOW_500;
    }

    if (this.args.parentAction.isSplitInactive) {
      return GRAY_400;
    }

    return null;
  }
}
